import React from "react";
import { createRoot } from "react-dom/client";

import App from "./App";
import { getConfig } from "./config";
import { initRealUserMonitoring } from "./realUserMonitoring";

if (process.env.NODE_ENV === "production") {
	initRealUserMonitoring({
		name: getConfig("name"),
		version: getConfig("version"),
		env: getConfig("env"),
		ddToken: getConfig("datadogrumclienttoken"),
		ddAppId: getConfig("datadogrumapplicationid"),
	});
}

if (getConfig("mswenabled")) {
	import("merchant-portal-data/worker.mock").then(({ worker }) => {
		worker.start({ onUnhandledRequest: "bypass" });
	});
}

const rootElement = document.createElement("div");
document.body.appendChild(rootElement);
const root = createRoot(rootElement);

root.render(<App />);
